import React from 'react';
const benefits = [{
  emoji: '⚡',
  title: 'Gagnez des heures de préparation chaque semaine',
  description: 'Ne perdez plus votre temps à chercher des exercices, construire vos progressions ou organiser vos séances. Ouvrez simplement le système, choisissez la séance adaptée à votre groupe et enseignez avec tout déjà prêt.'
}, {
  emoji: '👑',
  title: 'Enseignez avec plus de confiance',
  description: "Animez chaque entraînement avec une structure claire, des progressions efficaces et des outils professionnels qui vous permettront d'enseigner avec davantage d'assurance."
}, {
  emoji: '🤸',
  title: 'Faites progresser vos gymnastes plus rapidement',
  description: 'Développez leurs compétences techniques grâce à des exercices, des progressions et des séances organisées qui favorisent une évolution constante tout au long de la saison.'
}, {
  emoji: '😊',
  title: 'Proposez des entraînements plus professionnels',
  description: "Offrez des séances parfaitement organisées grâce à des ressources prêtes à l'emploi, des outils pédagogiques complets et un système conçu pour vous faire gagner du temps."
}];
export function BenefitsSection() {
  return <section className="py-6 px-4 sm:px-6 bg-white border-t-4 border-brand-ivory" data-id="element-16">
      <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-center text-brand-navy mb-4 uppercase leading-tight" data-id="element-17">
        CE QUI VA CHANGER POUR VOUS
      </h2>
      <div className="flex flex-col gap-2.5" data-id="element-18">
        {benefits.map(benefit => <article key={benefit.title} className="bg-brand-ivory border-l-4 border-brand-gold p-3.5 rounded-r-lg shadow-sm flex gap-3 items-start" data-id="element-19">
            <div className="text-xl shrink-0 leading-none mt-0.5" data-id="element-20">
              {benefit.emoji}
            </div>
            <div data-id="element-21">
              <h3 className="text-sm sm:text-base font-heading font-bold text-brand-navy mb-1 uppercase tracking-tight leading-tight" data-id="element-22">
                {benefit.title}
              </h3>
              <p className="text-brand-text text-sm font-medium leading-snug" data-id="element-23">
                {benefit.description}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}